// eslint-disable-next-line max-classes-per-file
import {
  CreateHearingSectionPeopleAnnotationRequest,
  HearingSectionPeopleAnnotation,
  UpdateHearingSectionPeopleAnnotationRequest,
} from '@ftr/annotations-contracts'
import { Uuid } from '@ftr/contracts/type/shared'

export const PEOPLE_ANNOTATIONS_ACTION_SCOPE = '[People Annotations]'
export class InitialisePeopleAnnotationsCommand {
  static readonly type = `${PEOPLE_ANNOTATIONS_ACTION_SCOPE} Initialise People Annotations`
  constructor(
    readonly courtSystemId: Uuid,
    readonly recordingId: Uuid,
    readonly audioSegmentId?: Uuid,
  ) {}
}

export class FetchPeopleAnnotationsCommand {
  static readonly type = `${PEOPLE_ANNOTATIONS_ACTION_SCOPE} Fetch People Annotations`
  constructor(
    readonly courtSystemId: Uuid,
    readonly recordingId: Uuid,
    readonly audioSegmentId?: Uuid,
  ) {}
}

export class CreateHearingSectionPeopleAnnotationsCommand {
  static readonly type = `${PEOPLE_ANNOTATIONS_ACTION_SCOPE} Create Hearing Section People Annotations`
  constructor(readonly peopleAnnotationsRequest: CreateHearingSectionPeopleAnnotationRequest) {}
}

export class UpdateHearingSectionPeopleAnnotationsCommand {
  static readonly type = `${PEOPLE_ANNOTATIONS_ACTION_SCOPE} Update Hearing Section People Annotations`
  constructor(
    readonly updateRequest: UpdateHearingSectionPeopleAnnotationRequest &
      Pick<HearingSectionPeopleAnnotation, 'hearingSectionId' | 'id'>,
  ) {}
}

export class DeleteHearingSectionPeopleAnnotationsCommand {
  static readonly type = `${PEOPLE_ANNOTATIONS_ACTION_SCOPE} Delete Hearing Section People Annotations`
  constructor(
    readonly deleteRequest: Pick<HearingSectionPeopleAnnotation, 'courtSystemId' | 'hearingSectionId' | 'id'>,
  ) {}
}
